var _defs, _style, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 25",
    width: 27,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 24,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAYCAMAAAA8nnbJAAAAAXNSR0IB2cksfwAAAQhQTFRFAAAA4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl4uPl0sEPDgAAAFh0Uk5TAAgtGw4dIRYXXZ/p7/Pu4rNwFFDn/v32+fz/oSc29JAYBOb38gNgxAr7OKBiuI9S9YDM0vrkLNDs8HYfvLQpIuU8Q9sjRVOJaAkeZDHomU7fAlsBmIFjOj/wEeMAAAEmSURBVHicddBLS8NAFAXgc9q0YCEKtVTwgYrUB1YEKdm4EAQRRBDxZ7oWwY3oXouNihi1DT6KSsRdqxOpmSaRycNDYLj3y4SbS8gwkQ/ZlTTs14Cb67+KXoZPvk3QBQSCvo95tqRNs+vRoBBUsPA8bnn17KfmFW7WVS9C5w2RGShEmkGGeE0svmspBBQviSUHIiefWEoNYrmtlV9dJGykTlT0x84c7biNmV1vToNfd1XaURrNt5vyn1bpOIgOJOZ56u9sjbexL85ox8E+sW53IrRA2woNG42sQpP6kTzCHW46L3/0XeOhaltOM5ymt3LVgmrY5lmwnJrZRNSwU3f7p3ERkGIVFu+9e2XzBwnDLh/eIIwDpBj2eFKq7iPVMGXw3PrHYvkFFDNPGRSNj44AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#e2e3e5}.c{fill:#b6b6b6}")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m13.5 23.9v-16.2h-13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m12.8 23l-12.8-17h25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m24.7 7.7h-22.4l4.5-7.2h13.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m13.5 24.3c-0.1 0-0.3 0-0.4-0.2l-13-16.2c-0.1-0.1-0.1-0.3 0-0.5q0.1-0.2 0.4-0.2h26q0.3 0 0.5 0.3c0 0.2 0 0.4-0.1 0.5l-13 16.2q-0.2 0.1-0.4 0.1zm-12.1-16.2l12.1 15 12.1-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m26.5 8.1h-26q-0.3 0-0.4-0.2c-0.1-0.1-0.1-0.3 0-0.5l4.5-7.1c0.1-0.2 0.2-0.3 0.4-0.3h17.1c0.1 0 0.3 0.1 0.3 0.3l4.5 7.1c0.1 0.2 0.1 0.4 0 0.5 0 0.1-0.2 0.2-0.4 0.2zm-25.2-0.9h24.4l-3.9-6.3h-16.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m13.5 24.3c-0.2 0-0.4-0.1-0.4-0.3l-8.5-23.4c-0.1-0.2 0-0.4 0.2-0.5 0.3-0.1 0.5 0 0.6 0.2l8.6 23.4c0 0.2-0.1 0.5-0.3 0.6q-0.1 0-0.2 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m13.5 23.9q-0.1 0-0.1-0.1c-0.3-0.1-0.4-0.3-0.3-0.6l8.5-22.9c0.1-0.2 0.4-0.4 0.6-0.3 0.3 0.1 0.4 0.4 0.3 0.6l-8.5 22.9c-0.1 0.3-0.3 0.4-0.5 0.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m7.7 8.1q-0.2 0-0.3-0.1c-0.2-0.1-0.2-0.4 0-0.6l5.8-7.2c0.1-0.2 0.4-0.2 0.6 0 0.2 0.1 0.2 0.4 0.1 0.6l-5.9 7.2q-0.1 0.1-0.3 0.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.4 8.1c-0.2 0-0.3 0-0.4-0.2l-5.9-7.2c-0.1-0.1-0.1-0.4 0.1-0.6 0.2-0.1 0.5-0.1 0.6 0.1l5.9 7.2c0.1 0.1 0.1 0.5-0.1 0.6q-0.1 0.1-0.2 0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondDefaultIcon);
export default __webpack_public_path__ + "static/media/DiamondDefaultIcon.6ed58b3b3b40f59429d6411933cdf2ae.svg";
export { ForwardRef as ReactComponent };